import { useState } from "react";

import { EmailValidate, FormValidate } from "../../../components/formValidate";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import "./admin.css";
import { companyLogin } from "./auth.api";

let required = ["email", "password"];

export default function Userlogin(props) {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState({});
  const [submit, setSubmit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const handleChange = (e) => {
    let erroremail = false;

    if (e.target.name === "email") {
      erroremail = !EmailValidate(e.target.value);

      setError({ ...error, email: erroremail });
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    setSubmit(true);
    const error = FormValidate(formData, required);
    setError(error);
    e.preventDefault();

    if (Object.keys(error).length === 0) {
      companyLogin(formData)
        .then((res) => {
          setSubmit(false);
          sessionStorage.setItem("token", res.token);
          props.login(res.token);
          props.history.push({
            pathname: "/dashboard",
          });
        })
        .catch((error) => {
          setSubmit(false);

          setSnackMessage(error?.response?.data?.message || "Login failed");
          setIsSnackError(true);
          setSnackOpen(true);
        });
    } else {
      setSubmit(false);
    }
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  return (
    <div className="admin-login-page">
      <div className="">
        <img
          src="/resources/logo/logo.png"
          alt=""
          className="admin-login-logo"
        />
      </div>
      <div className="admin-login-container ">
        <>
          <div className="admin-login-title">USER</div>
          <form
            className=""
            autoComplete="off"
            noValidate
            onSubmit={handleSubmit}
          >
            <div className="login-input">
              <TextField
                {...props}
                type="text"
                required
                onChange={handleChange}
                label="Email"
                error={error.email}
                name="email"
                placeholder="Enter your email"
              />
            </div>
            <div className="login-input">
              <TextField
                {...props}
                label="Password"
                type="password"
                required
                name="password"
                error={error.password}
                onChange={handleChange}
                placeholder="Enter your password"
              />
            </div>

            <div className="butnCnt">
              <button
                disabled={submit}
                {...props}
                className="btn btn-primary"
                type="submit"
              >
                Login
              </button>
            </div>
          </form>
        </>
      </div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
